import classNames from 'classnames';
import React from 'react';

import DefaultButton from 'components/atoms/DefaultButton';

import './styles.less';

const DefaultDrawerFooterButton = ({
  onClick,
  children,
  className,
  disabled,
  loading
}: {
  onClick?: () => void;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  disabled?: boolean;
  loading?: boolean;
}) => (
  <DefaultButton
    className={classNames('DefaultDrawerFooterButton', className)}
    type="primary"
    onClick={onClick}
    size="large"
    disabled={disabled}
    loading={loading}
  >
    {children}
  </DefaultButton>
);

export default DefaultDrawerFooterButton;
